import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { TableBody } from '@insurancemenu/imenu-components-lib';
import { useRootStore } from 'store/rootStore';
import InboundLeadModal from 'components/groups-dashboard/InboundLeadModal';
import AssignAgentsModal from 'components/common/group/content/AssignAgentsModal';
import { useGroupDashboardPageStore } from 'store/pages/groups-dashboard/pageStore';
import GroupsTableRow from './GroupsTableRow';
import GroupsTableHeader from './GroupsTableHeader';
import { TableStyled } from './styles';

const GroupsTable: React.FC = observer(() => {
  // TO_DO: Refactor this after group profile overhaul
  const { groupsDashboardController } = useRootStore();
  const { inboundLeadModalStore, groups, groupRequestParams, getInitialData, isLoading, totalPages, setPage } =
    useGroupDashboardPageStore();

  function closeAssignAgentsModal(): void {
    groupsDashboardController.closeAssignAgentsModal();
  }

  useEffect(() => {
    void getInitialData();
  }, [
    groupRequestParams.filter,
    groupRequestParams.sortBy,
    groupRequestParams.sortOrder,
    groupRequestParams.page,
    groupRequestParams.fullView,
  ]);

  return (
    <>
      <TableStyled
        loading={isLoading}
        totalElements={groups.length}
        maxHeight="75rem"
        // minHeight is set to 60rem so dropdown options remain visible
        // when there are only a few groups
        minHeight="60rem"
        pagination={{ onPageChange: setPage, maxPage: totalPages, tablePage: groupRequestParams.page }}
      >
        <GroupsTableHeader />
        <TableBody>
          {groups.map((group) => (
            <GroupsTableRow groupDelegate={group} key={group.data.id} />
          ))}
        </TableBody>
      </TableStyled>
      <InboundLeadModal modalStore={inboundLeadModalStore} />
      <AssignAgentsModal
        show={groupsDashboardController.showAssignAgentsModal}
        onClose={closeAssignAgentsModal}
        isClosable
      />
    </>
  );
});
export default GroupsTable;
